<template>
  <div class="d-flex text-mcf-color" style="z-index:200">
    <!-- 登入前 -->
    <b-button class="bg-customize border-customize w-100 rounded-0" v-if="!hasLogged" @click="login">{{ nonLoginWording }}</b-button>
    <!-- 登入後 -->
    <template v-else>
      <div class="mr-n1 flex-grow-1 px-3 d-flex align-items-center font-size-sm border mcf-border-color ">
        <span class="material-icons-outlined md-18 mr-1 text-customize">shopping_cart</span>
        {{ $t('redeem.cart.total') }}
        <span class="mx-1" :class="{'animate__animated animate__bounce': isIncreaseAnimateShow}">{{ redeemItemCount }}</span>
        {{ `${$t('redeem.cart.item')} ${$t('redeem.cart.used')}` }}
        <span class="font-size-lg text-danger mx-1">{{ redeemItemTotalPoint }}</span>
        {{ pointUnit }}
      </div>
      <b-button class="bg-customize border-customize w-25 rounded-0 text-nowrap" :class="redeemButtonClass" :style="redeemButtonStyle" @click="goCart">{{ redeemButtonWording }}</b-button>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import pageSettingGetter from '@/utils/pageSettingGetter';
import commonTool from '@/utils/commonTool';

const redeemRoutes = commonTool.getIgnoreRoutes();

export default {
  data() {
    return {
      // 顯示增加動畫
      isIncreaseAnimateShow: false,
      // 點數單位
      pointUnit: '',
      // 未登入文案
      nonLoginWording: '',
      // 兌換按鈕文案
      redeemButtonWording: '',
    };
  },
  computed: {
    ...mapState('redeemItem', ['cartList']),
    // 是否登入
    hasLogged() {
      return !!this.$store.state.accessToken;
    },
    // 兌禮商品數量
    redeemItemCount() {
      return this.cartList.reduce((sum, item) => sum + item.qty, 0);
    },
    // 兌換按鈕 class
    redeemButtonClass() {
      const vm = this;
      // 數量為0：套bg-gray700 disabled，數量不為0：套 bg-transparent
      return {
        'bg-gray700 disabled': vm.redeemItemCount === 0,
        'bg-transparent': vm.redeemItemCount !== 0,
      };
    },
    // 兌換按鈕 style
    redeemButtonStyle() {
      if (this.redeemItemCount) return {};
      // 無商品數量，加入按鈕不顯示手指 style
      return { cursor: 'not-allowed !important' };
    },
    // 兌禮商品點數總和
    redeemItemTotalPoint() {
      return this.cartList.reduce((sum, item) => sum + item.qty * item.point, 0);
    },
  },
  methods: {
    goCart() {
      const vm = this;
      // 有購物車數量時，才可購買
      if (vm.redeemItemCount > 0) vm.$router.push({ name: 'redeemCart', query: { companyid: vm.$store.state.companyId, membersourceid: vm.$store.state.memberSourceId } });
    },
    // 登入
    login() {
      const query = redeemRoutes.includes(this.$route.name) ? { verify: 'true' } : {};
      commonTool.login(window.location.pathname, query);
    },
  },
  watch: {
    // 監控兌禮商品數量異動
    redeemItemCount(newValue, oldValue) {
      const vm = this;
      // 數量不變、減少，直接 return
      if (newValue <= oldValue) return;
      // 數量增加，顯示動畫
      vm.isIncreaseAnimateShow = true;
      setTimeout(() => {
        // 初始化
        vm.isIncreaseAnimateShow = false;
      }, 1000);
    },
  },
  created() {
    const vm = this;
    // 取得頁面設定資料
    vm.$store.dispatch('getPageSetting', 'RedeemItem')
      .then((setting) => {
        vm.pointUnit = pageSettingGetter.getFunctionWording(setting, 'UserPointUnit');
        vm.nonLoginWording = pageSettingGetter.getFunctionWording(setting, 'CartNonLogin');
        vm.redeemButtonWording = pageSettingGetter.getFunctionWording(setting, 'CartRedeemButton');
      });
  },
};
</script>
